import { ModalSectionMode } from '@powerduck/common/enums/modal';
import AppRoutes from '../../app-routes';
import { AppState } from '../../app-state';
import './css/toolbar-user.css';

export default class ToolbarUserMenu {

	static renderMenu(dummyUser: number) {
		if (AppState.user == null) {
			return null;
		}

		const showSmall = !(AppState.user.DisplayName == AppState.user.Email);

		return (
			<div class="dropdown menu-user" data-incrementor={dummyUser}>
				<a href="javascript:" class="dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					<span>
						<i class="icon icon-user"></i>
					</span>
				</a>

				<div class="dropdown-menu dropdown-menu-right dropdown-menu-accout">
					<div class="user-menu">
						<div class="user-info text-center p-3">
							<i class="icon icon-user"></i>
							<p class="mt-1 mb-0">
								<span style="display:block">{AppState.user.DisplayName}</span>
								{showSmall &&
									<small style="margin-top: -5px; display: block;">{AppState.user.Email}</small>
								}
							</p>
						</div>
						<h6 class="dropdown-header">{AppState.resources.menuVisitor}</h6>
						<a class="dropdown-item" href="/home">
							<i class="fa fa-calendar me-2"></i>
							{AppState.resources.menuEvents}
						</a>
						<a class="dropdown-item" href="/my-tickets">
							<i class="fa fa-tags me-2"></i>
							{AppState.resources.menuMyTickets}
						</a>
						<router-link class="dropdown-item" to={AppRoutes.editProfileNew.path}>
							<i class="fa fa-user me-2"></i>
							{AppState.resources.editProfileBreadcrumbTitle}
						</router-link>
						<div class="dropdown-divider"></div>
						<h6 class="dropdown-header">{AppState.resources.promoterInfoShort}</h6>
						<a class="dropdown-item" href="/create-event">
							<i class="fas fa-fw fa-plus-circle me-2"></i>
							{AppState.resources.createNewEvent}
						</a>
						<router-link class="dropdown-item" to={AppRoutes.eventManagementSelection.path}>
							<i class="fa fa-calendar me-2"></i>
							{AppState.resources.menuMyEvents}
						</router-link>
						<a class="dropdown-item" href="/acl-checking-selection">
							<i class="far fa-check-square me-2"></i>
							{AppState.resources.menuAccessControl}
						</a>

						<div class="dropdown-divider"></div>
						<a class="dropdown-item mb-1" href="/logout">
							<i class="fa fa-power-off me-2"></i>
							{AppState.resources.menuLogout}
						</a>
					</div>
				</div>
			</div>
		);
	}
}
